<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n box-delivery-title">
      <div class="delivery-title-icon">
        <img :src="iconUrl" alt="" class="img-responsive">
      </div>
      <div class="delivery-title">倉庫管理</div>
    </h2>
    <div class="hpanel">
      <nav-tabs :tab="tab" :hasWarehouseUsing="hasWarehouseUsing" />
      <tab-content :tab="tab" :hasWarehouseUsing="hasWarehouseUsing" />
    </div>
  </div>
</template>

<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'
import WarehouseService from '@/services/warehouseservice'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      loader: null,
      iconUrl: '',
      hasWarehouseUsing: false
    }
  },
  methods: {
    async getWarehouseIcon () {
      let params = {
        type: 'salmonYamato'
      }
      await WarehouseService.getWarehouseIcon(params)
        .then(response => {
          if (response.data) {
            this.iconUrl = response.data.iconUrl
          }
        })
    }
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
    let seller = this.$store.getters.getUser
    if (seller.yamatoWarehouseUse === '1') {
      this.hasWarehouseUsing = true
    }
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['top', 'delivery-request-list', 'delivery-request-registration', 'update-delivery-request-registration', 'expense-detail-actual-shipment', 'expense-detail-storage-fee', 'receive-amount-diff-setting'].includes(toTab)) {
        this.tab = toTab
      } else {
        this.$router.push('/not-found')
      }
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (['top', 'delivery-request-list', 'delivery-request-registration', 'update-delivery-request-registration', 'expense-detail-actual-shipment', 'expense-detail-storage-fee', 'receive-amount-diff-setting'].includes(this.tab)) {
      this.loader = this.$loading.show()
    } else {
      this.$router.push('/not-found')
    }
    this.getWarehouseIcon()
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/DeliveryRequests.vue